module.exports = __webpack_public_path__ + "img/Humanisme_Tida_og_samfunnsforholdene1.da7dbbc8.jpg";